import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  webcamFileSwitchButton: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));
